import { createContext, useContext, useState } from "react";

const LoginRequiredContext = createContext();

export const LoginRequiredProvider = ({ children }) => {

  const [isOpen, setIsOpen] = useState(false);

  const openLoginModal = () => {
    setIsOpen(true);
  };

  const closeLoginModal = () => {
    setIsOpen(false);
  };

  return (
    <LoginRequiredContext.Provider
      value={{
        isOpen,
        openLoginModal,
        closeLoginModal
      }}
    >
      {children}
    </LoginRequiredContext.Provider>
  );
};

export const useLoginRequiredModal = () =>
  useContext(LoginRequiredContext);